import React, { useEffect, useState } from 'react';
import config from '../../config';
// import './DeliveryBoys.css'; // Optional custom styles
import { Modal, Button } from 'react-bootstrap'; // Using React-Bootstrap for modal
import { FaEdit } from 'react-icons/fa';

export default function DeliveryBoys() {
    const [deliveryBoys, setDeliveryBoys] = useState([]);
    const [filteredDeliveryBoys, setFilteredDeliveryBoys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name'); // Default search field
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const [showEditModal, setShowEditModal] = useState(false); // Edit modal state
    const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null); // Selected delivery boy details
    const [editingDeliveryBoy, setEditingDeliveryBoy] = useState(null); // Editing delivery boy
    const { API_URL } = config;

    const fetchDeliveryBoys = async () => {
        try {
            const res = await fetch(`${API_URL}/api/auth/getAllDeliveryBoys`);
            const data = await res.json();
            setDeliveryBoys(data.deliveryBoys || []);
            setFilteredDeliveryBoys(data.deliveryBoys || []); // Initialize filtered list
            setLoading(false);
        } catch (error) {
            console.error("Error fetching delivery boys:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDeliveryBoys();
    }, []);

    useEffect(() => {
        // Filter delivery boys based on search term and field
        const filtered = deliveryBoys.filter(deliveryBoy =>
            deliveryBoy[searchField]?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredDeliveryBoys(filtered);
    }, [searchTerm, searchField, deliveryBoys]);

    const handleSearchTermChange = event => {
        setSearchTerm(event.target.value);
    };

    const handleSearchFieldChange = event => {
        setSearchField(event.target.value);
    };
    const handleToggleBan = async (deliveryBoy) => {
        const action = deliveryBoy.isBanned ? "unban" : "ban";
        if (window.confirm(`Are you sure you want to ${action} this delivery boy?`)) {
            try {
                const res = await fetch(`${API_URL}/api/auth/updateBanDeliveryBoy/${deliveryBoy._id}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ ban: !deliveryBoy.isBanned })
                });
    
                const data = await res.json();
                alert(data.message);
                if (data.executed) {
                    fetchDeliveryBoys(); // Refresh the list
                }
            } catch (error) {
                console.error("Error updating ban status:", error);
                alert("Failed to update ban status");
            }
        }
    };
    
    const handleDelete = async (deliveryBoyId) => {
        if (window.confirm("Are you sure you want to delete this delivery boy?")) {
            try {
                const res = await fetch(`${API_URL}/api/auth/deleteDeliveryBoyById/${deliveryBoyId}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await res.json();
                alert(data.message);
                if (data.executed) fetchDeliveryBoys();
            } catch (error) {
                console.error("Error deleting delivery boy:", error);
                alert("Failed to delete delivery boy");
            }
        }
    };

    const handleShowModal = (deliveryBoy) => {
        setSelectedDeliveryBoy(deliveryBoy);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDeliveryBoy(null);
    };

    const handleEdit = (deliveryBoy) => {
        setEditingDeliveryBoy({...deliveryBoy});
        setShowEditModal(true);
    };

    const handleEditChange = (field, value) => {
        setEditingDeliveryBoy(prev => ({...prev, [field]: value}));
    };

    const handleUpdateDeliveryBoy = async () => {
        try {
            const { _id, ...updateData } = editingDeliveryBoy;
            const res = await fetch(`${API_URL}/api/auth/updateDeliveryBoyById`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: _id, updateData }),
            });
            const data = await res.json();
            alert(data.message || 'Delivery boy updated successfully');
            setShowEditModal(false);
            fetchDeliveryBoys();
        } catch (error) {
            console.error("Error updating delivery boy:", error);
            alert("Failed to update delivery boy");
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "98vh" }}>
                <div className="spinner-grow text-success" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <h1 className="text-2xl font-bold mb-4">DELIVERY BOY</h1>

            <div className="d-flex mb-3">
                <select
                    className="form-select me-3"
                    value={searchField}
                    onChange={handleSearchFieldChange}
                    style={{ maxWidth: '200px' }}
                >
                    <option value="name">Name</option>
                    <option value="email">Email</option>
                    <option value="contact">Contact</option>
                    <option value="city">City</option>
                    {/* <option value="gender">Gender</option> */}
                </select>

                <input
                    type="text"
                    placeholder={`Search by ${searchField}...`}
                    value={searchTerm}
                    onChange={handleSearchTermChange}
                    className="form-control rounded-xl"
                />
            </div>

            <div className="table-responsive">
                <table className="table table-hover bg-white">
                    <thead>
                        <tr className="bg-gray-100 rounded-t-lg">
                            <th className="py-2 px-4 border-black border-b text-left font-semibold rounded-tl-lg">Name</th>
                            <th className="py-2 px-4 border-black border-b text-left font-semibold">Email</th>
                            <th className="py-2 px-4 border-black border-b text-left font-semibold">Contact</th>
                            <th className="py-2 px-4 border-black border-b text-left font-semibold">City</th>
                            <th className="py-2 px-4 border-black border-b text-left font-semibold rounded-tr-lg">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredDeliveryBoys.map(deliveryBoy => (
                            <tr key={deliveryBoy._id}>
                                <td className="py-2 px-4 border-b">{deliveryBoy.name}</td>
                                <td className="py-2 px-4 border-b">{deliveryBoy.email}</td>
                                <td className="py-2 px-4 border-b">{deliveryBoy.contact}</td>
                                <td className="py-2 px-4 border-b">{deliveryBoy.city}</td>
                                <td>
                                    <button
                                        className="btn btn-primary btn-sm me-2"
                                        onClick={() => handleShowModal(deliveryBoy)}
                                    >
                                        Details
                                    </button>
                                    <button
                                        className="btn btn-info btn-sm me-2"
                                        onClick={() => handleEdit(deliveryBoy)}
                                        title="Edit"
                                    >
                                        <FaEdit /> Edit
                                    </button>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDelete(deliveryBoy._id)}
                                    >
                                        Delete
                                    </button>
                                    <button
                                       className={`btn btn-${deliveryBoy.isBanned ? 'success' : 'warning'} btn-sm ms-2`}
                                        onClick={() => handleToggleBan(deliveryBoy)}
                                    >
                                       {deliveryBoy.isBanned ? 'Unban' : 'Ban'}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {selectedDeliveryBoy && (
                <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Delivery Boy Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Complete Information</h5>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                        handleEdit(selectedDeliveryBoy);
                                        handleCloseModal();
                                    }}
                                >
                                    <FaEdit className="me-1" /> Edit Details
                                </button>
                            </div>
                            {/* Personal Details */}
                            <h5 className="mb-3">Personal Details</h5>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <p><strong>Name:</strong> {selectedDeliveryBoy.name}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Gender:</strong> {selectedDeliveryBoy.gender || 'N/A'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Date of Birth:</strong> {new Date(selectedDeliveryBoy.DOB).toLocaleDateString()}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>City:</strong> {selectedDeliveryBoy.city || 'N/A'}</p>
                                </div>
                            </div>

                            {/* Contact Information */}
                            <h5 className="mb-3">Contact Information</h5>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <p><strong>Email:</strong> {selectedDeliveryBoy.email}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Contact:</strong> {selectedDeliveryBoy.contact}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>WhatsApp Contact:</strong> {selectedDeliveryBoy.whatsappContact || 'N/A'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Alternate Number:</strong> {selectedDeliveryBoy.alternateNumber || 'N/A'}</p>
                                </div>
                            </div>

                            {/* Professional Details */}
                            <h5 className="mb-3">Professional Details</h5>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <p><strong>Employee ID:</strong> {selectedDeliveryBoy.employeeId || 'N/A'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Joining Date:</strong> {new Date(selectedDeliveryBoy.joiningDate).toLocaleDateString()}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Experience:</strong> {selectedDeliveryBoy.experience || 'N/A'} years</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Skills:</strong> {selectedDeliveryBoy.skills?.join(', ') || 'N/A'}</p>
                                </div>
                            </div>

                            {/* Document Images */}
                            <h5 className="mb-3">Uploaded Documents</h5>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <p>
                                        <strong>PAN Card:</strong>
                                        {selectedDeliveryBoy.pancardPic ? (
                                            <Button className='ml-2'
                                                variant="link"
                                                onClick={() => window.open(selectedDeliveryBoy.pancardPic, '_blank')}
                                            >
                                                View Image
                                            </Button>
                                        ) : (
                                            ' Not Available'
                                        )}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <p>
                                        <strong>ID Proof:</strong>
                                        {selectedDeliveryBoy.idProofPic ? (
                                            <Button className='ml-2'
                                                variant="link"
                                                onClick={() => window.open(selectedDeliveryBoy.idProofPic, '_blank')}
                                            >
                                                View Image
                                            </Button>
                                        ) : (
                                            ' Not Available'
                                        )}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <p>
                                        <strong>Driving License:</strong>
                                        {selectedDeliveryBoy.drivingLicensePic ? (
                                            <Button className='ml-2'
                                                variant="link"
                                                onClick={() => window.open(selectedDeliveryBoy.drivingLicensePic, '_blank')}
                                            >
                                                View Image
                                            </Button>
                                        ) : (
                                            ' Not Available'
                                        )}
                                    </p>
                                </div>
                            </div>

                            {/* Bank Details */}
                            <h5 className="mb-3">Bank Details</h5>
                            {selectedDeliveryBoy.bankDetails ? (
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Account Number</th>
                                                <th>IFSC Code</th>
                                                <th>Branch</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{selectedDeliveryBoy.bankDetails.accountNumber || 'N/A'}</td>
                                                <td>{selectedDeliveryBoy.bankDetails.IFSCCode || 'N/A'}</td>
                                                <td>{selectedDeliveryBoy.bankDetails.branchCode || 'N/A'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <p>No bank details available.</p>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Delivery Boy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editingDeliveryBoy && (
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control" value={editingDeliveryBoy.name || ''}
                                    onChange={(e) => handleEditChange('name', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Email</label>
                                <input type="email" className="form-control" value={editingDeliveryBoy.email || ''}
                                    onChange={(e) => handleEditChange('email', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Contact</label>
                                <input type="text" className="form-control" value={editingDeliveryBoy.contact || ''}
                                    onChange={(e) => handleEditChange('contact', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">City</label>
                                <input type="text" className="form-control" value={editingDeliveryBoy.city || ''}
                                    onChange={(e) => handleEditChange('city', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Gender</label>
                                <select className="form-control" value={editingDeliveryBoy.gender || ''}
                                    onChange={(e) => handleEditChange('gender', e.target.value)}>
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Status</label>
                                <select className="form-control" value={editingDeliveryBoy.status || ''}
                                    onChange={(e) => handleEditChange('status', e.target.value)}>
                                    <option value="verified">Verified</option>
                                    <option value="unverified">Unverified</option>
                                    <option value="pending">Pending</option>
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label className="form-label">Current Address</label>
                                <textarea className="form-control" value={editingDeliveryBoy.currentAddress || ''}
                                    onChange={(e) => handleEditChange('currentAddress', e.target.value)} rows="2" />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label">Permanent Address</label>
                                <textarea className="form-control" value={editingDeliveryBoy.permanentAddress || ''}
                                    onChange={(e) => handleEditChange('permanentAddress', e.target.value)} rows="2" />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleUpdateDeliveryBoy}>Save Changes</Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
